class TimeList {
    constructor(element) {
        this.element = element
        this.baseRadioTimeTemplate = this.element[0].querySelector('#radio-time-template');
    }
    fillElement(data) {
        const formGroup = $(this.baseRadioTimeTemplate.content.cloneNode(true));
        const inputEl = formGroup.find('input');

        formGroup.find('.radio-text').text(data.time);
        inputEl.val(data.time);
        inputEl.attr('name', 'time');
        inputEl.attr('disabled', !data.free);

        return formGroup;
    }

    fillTimeList(response) {
        $(this.element).html('');
        const newTimesList = [];

        const timesList = response[0].data.slots;

        if (!timesList.length) {
            $(this.element).html(response[1]);
            return;
        }

        timesList.forEach((item) => newTimesList.push(this.fillElement(item)));

        $(this.element).append(newTimesList);
    }
}
